import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export interface KpiCardProps {
  title: string;
  value: string;
  subtitle: string;
  icon: React.ReactNode;
  accent?: "default" | "warning" | "success";
  onClick?: () => void;
  tooltip?: string;
}

export function KpiCard({
  title,
  value,
  subtitle,
  icon,
  accent = "default",
  onClick,
  tooltip,
}: KpiCardProps) {
  const accentBorder =
    accent === "warning"
      ? "border-l-amber-500"
      : accent === "success"
        ? "border-l-emerald-500"
        : "border-l-border";

  return (
    <Card
      className={`border-l-[3px] ${accentBorder} ${onClick ? "cursor-pointer hover:bg-muted/50 transition-colors" : ""}`}
      onClick={onClick}
    >
      <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
        <CardTitle className="text-xs font-medium uppercase tracking-wider text-muted-foreground" title={tooltip}>
          {title}
        </CardTitle>
        <span className="text-muted-foreground">{icon}</span>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-semibold tabular-nums tracking-tight">
          {value}
        </div>
        <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
      </CardContent>
    </Card>
  );
}
